/**
 * Shopify collection handles are the URL names of a collection, e.g.
 * "washing-machines": lowercase letters and digits, separated by single
 * hyphens or underscores. Returns the normalized handle or null.
 */
const HANDLE_REGEX = /^[a-z0-9]+(?:[-_][a-z0-9]+)*$/;
const MAX_HANDLE_LENGTH = 255;
const normalizeShopifyCollectionHandle = value => {
  if (typeof value !== 'string') return null;
  const handle = value.trim().toLowerCase();
  if (!handle || handle.length > MAX_HANDLE_LENGTH) return null;
  return HANDLE_REGEX.test(handle) ? handle : null;
};
module.exports = {
  normalizeShopifyCollectionHandle
};